
<ng-container >
  <button mat-button [matMenuTriggerFor]="menu" class="daily-settlements-button" [disabled]="loading$ | async">Download Report
    <mat-icon matListItemIcon class="flex-shrink-0" class="daily-settlements-icon">download</mat-icon>
  </button>

  <mat-menu #menu="matMenu" xPosition="before">
    <button mat-menu-item color="primary" class="daily-settlements-button-pdf" (click)="downloadDailySettlementReport()" data-test="tx-settlement-daily-report-download-download-daily-settlement-report-button">
      <mat-icon matListItemIcon class="flex-shrink-0" class="daily-settlements-icon-pdf">picture_as_pdf</mat-icon>
      <div class="daily-settlements-text-pdf">Download PDF</div>
    </button>

    <button mat-menu-item color="primary" class="daily-settlements-button-csv" (click)="downloadDailySettlementReportCSV()" data-test="tx-settlement-daily-report-download-download-daily-settlement-report-csv-button">
      <mat-icon matListItemIcon class="flex-shrink-0" class="daily-settlements-icon-csv">download</mat-icon>
      <div class="daily-settlements-text-csv">Download CSV</div>
    </button>

    <button mat-menu-item color="primary" class="daily-settlements-button-merchant-report" (click)="downloadDailyMerchantReport()" data-test="tx-settlement-daily-report-download-download-daily-merchant-report-button">
      <mat-icon matListItemIcon class="flex-shrink-0" class="daily-settlements-icon-merchant-report">summarize</mat-icon>
      <div class="daily-settlements-text-merchant-report">Download Merchant Report</div>
    </button>
  </mat-menu>

  @if (loading$ | async) {
    <odin-loading-spinner
      class="loading-spinner pt-2"
      [active]="true"
      [diameter]="20"
      [strokeWidth]="2"
      [colour]="'primary'">
    </odin-loading-spinner>
  }
</ng-container>